var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slide-scroll"},[_c('div',{ref:"slideListWarp",staticClass:"slide-list-warp"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }